import React, { ComponentType, useCallback, useEffect, useState } from 'react';
import { Header } from '../Header';
import Box from '@mui/material/Box';
import { activityItem } from '../../../schema/activity-item';
import { activityPrice } from '../../../schema/activityPrice';
import { statuses } from '../../../schema/statuses';
import { activityExtra } from '../../../schema/activityExtra';
import { enumItems } from '../../../schema/enumItems';
import { guideWage } from '../../../schema/guideWage';
import { guideCost } from '../../../schema/guideCost';
import { serviceProvider } from '../../../schema/serviceProvider';
import { driver } from '../../../schema/driver';
import { enumItemsWithSalesPartner } from '../../../schema/enumItemsWithSalesPartner';
import { address } from '../../../schema/address';
import { salesPartner } from '../../../schema/salesPartner';
import { restaurant } from '../../../schema/restaurant';
import { accommodation } from '../../../schema/accommodation';
import { accommodationType } from '../../../schema/accommodationType';
import { accommodationPrice } from '../../../schema/accommodationPrice';
import { rate } from '../../../schema/rate';
import { contact } from '../../../schema/contact';
import { bankAccount } from '../../../schema/bankAccount';
import { color } from '../../../schema/color';
import { roomType } from '../../../schema/roomType';
import { languageSkills } from '../../../schema/languageSkills';
import { singleStripperReservation } from '../../../schema/singleStripperReservation';
import { roomReservation } from '../../../schema/roomReservation';
import { enumItemsWithColor } from '../../../schema/enumItemsWithColor';
import { service } from '../../../schema/service';
import { servicePrice } from '../../../schema/servicePrice';
import { partnerName } from '../../../schema/partnerName';
import { competitor } from '../../../schema/competitor';
import { competitorPrice } from '../../../schema/competitorPrice';
import { promotions } from '../../../schema/promotions';
import { corporate } from '../../../schema/corporate';
import { corporatePayment } from '../../../schema/corporatePayment';
import Link from '@mui/material/Link';
import { Paper, Stack } from '@mui/material';

const PATH_TO_SCHEMA: any = {
  accommodations: accommodation,
  'accommodation-prices': accommodationPrice,
  'accommodation-providers': enumItems.accommodationProvider,
  'accommodation-types': accommodationType,
  'activity-categories': enumItems.activityCategory,
  'activity-extras': activityExtra,
  'activity-items': activityItem,
  'activity-prices': activityPrice,
  'activity-statuses': statuses.activityStatus,
  addresses: address,
  'address-types': enumItems.addressType,
  bars: enumItems.bar,
  'bank-accounts': bankAccount,
  'booked-bies': enumItemsWithColor.bookedBy,
  'booking-agents': enumItemsWithSalesPartner.bookingAgent,
  'booking-statuses': statuses.booking,
  'bus-providers': enumItems.busProvider,
  'bus-statuses': statuses.bus,
  colors: color,
  competitors: competitor,
  'competitor-prices': competitorPrice,
  contacts: contact,
  corporate: corporate,
  'corporate-payments': corporatePayment,
  countries: enumItems.country,
  currencies: enumItems.currency,
  drivers: driver,
  flights: enumItems.flight,
  'group-statuses': statuses.group,
  'group-types': enumItems.groupType,
  'guide-cost-statuses': statuses.guideCostStatus,
  'guide-costs': guideCost,
  'guide-statuses': statuses.guide,
  'guide-wages': guideWage,
  languages: enumItems.language,
  'language-levels': enumItems.languageLevel,
  'language-skills': languageSkills,
  'legal-entities': enumItems.legalEntity,
  'paid-by': enumItems.paidBy,
  'partner-daytimes': enumItems.partnerDaytime,
  'partner-names': partnerName,
  'payment-dues': enumItems.paymentDue,
  'payment-methods': enumItems.paymentMethod,
  promotions: promotions,
  rates: rate,
  restaurants: restaurant,
  'reservation-cost-statuses': statuses.reservationCostStatus,
  'reservation-statuses': statuses.reservationStatus,
  'room-reservations': roomReservation,
  'room-types': roomType,
  'sales-partners': salesPartner,
  services: service,
  'service-prices': servicePrice,
  'service-providers': serviceProvider,
  'service-provider-types': enumItems.serviceProviderType,
  'service-reservation-statuses': statuses.serviceReservationStatus,
  'service-types': enumItems.serviceType,
  'single-stripper-reservations': singleStripperReservation,
  'strip-bars': enumItems.stripBar,
  'stripper-reservation-statuses': statuses.stripperReservationStatus,
  'stripper-roles': enumItems.stripperRole,
  'stripper-statuses': statuses.stripper,
  'user-types': enumItems.userType,
  vehicles: enumItems.vehicle,
};

export const Database: ComponentType = () => {
  const [loading, setLoading] = useState(false);
  const [schemas, setSchemas] = useState([]);

  useEffect(() => {
    document.title = `Zoe - Databases`;
  }, []);

  const fetchSchemas = useCallback(() => {
    const schemaArray: any = [];

    Object.keys(PATH_TO_SCHEMA).forEach((table: string) => {
      schemaArray.push({
        url: table,
        value: PATH_TO_SCHEMA[table],
      });
    });

    setSchemas(schemaArray);
  }, []);

  useEffect(() => {
    fetchSchemas();
  }, []);

  return (
    <>
      <Header title={'Database'} />

      <Box
        sx={{
          padding: '15px',
          flexGrow: 1,
        }}
      >
        <Box
          component={Paper}
          sx={{
            padding: '15px',
            overflow: 'auto',
            maxHeight: 'calc(100vh - 70px)',
          }}
        >
          {schemas.map((schema: any) => {
            return (
              <Stack>
                <Link target="_blank" href={`/data/${schema.url}`}>
                  {schema.value.name}
                </Link>
              </Stack>
            );
          })}
        </Box>
      </Box>
    </>
  );
};
